export default function clearHtml(value) {
    return value.replace(/<(\w+.+?)(style=)[^>]+>/ig,'<$1>')
}
